import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['passwordField', 'privateKeyField', 'requiredControl'];

  static values = { publickey: { type: String, default: 'publickey_auth' } };

  authMethodChanged(event) {
    const { target } = event.detail;
    this.apply(target.getAttribute('value'));
  }

  /**
   * @private
   */
  apply(authMethod) {
    const publickey = authMethod === this.publickeyValue;

    this.passwordFieldTargets.forEach((field) => {
      field.hidden = publickey;
    });
    this.privateKeyFieldTargets.forEach((field) => {
      field.hidden = !publickey;
    });
    this.requiredControlTargets.forEach((control) => {
      control.required = !control.closest('[hidden]');
    });
  }
}
